// Check if document is already ready, or wait for it
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initTabs);
} else {
  // Document is already ready
  initTabs();
}

function initTabs() {
  const tabs = document.querySelectorAll(
    '.product-tabs-container [role="tab"]',
  );

  if (!tabs.length) {
    return;
  }

  const panels = document.querySelectorAll(
    '.product-tabs-container [role="tabpanel"]',
  );

  const switchTab = (newTab) => {
    const oldTab = document.querySelector(
      '.product-tabs-container [role="tab"][aria-selected="true"]',
    );

    const newPanel = document.querySelector(
      `.product-tabs-container #${newTab.getAttribute("aria-controls")}`,
    );

    const oldPanel = document.querySelector(
      `.product-tabs-container #${oldTab.getAttribute("aria-controls")}`,
    );

    if (!oldTab || !newPanel || !oldPanel) {
      return;
    }

    // Update the active tab
    oldTab.setAttribute("aria-selected", "false");
    oldTab.setAttribute("tabindex", "-1");
    newTab.setAttribute("aria-selected", "true");
    newTab.setAttribute("tabindex", "0");
    newTab.focus();

    // Update panels visibility
    oldPanel.hidden = true;
    newPanel.hidden = false;
  };

  tabs.forEach((tab, index) => {
    tab.addEventListener("click", (e) => {
      e.preventDefault();
      switchTab(e.currentTarget);
    });

    tab.addEventListener("touchstart", (e) => {
      e.preventDefault();
    });

    tab.addEventListener("touchend", (e) => {
      e.preventDefault();
      switchTab(e.currentTarget);
    });

    tab.addEventListener("keydown", (e) => {
      let newIndex;
      if (e.key === "ArrowRight") {
        newIndex = (index + 1) % tabs.length;
      } else if (e.key === "ArrowLeft") {
        newIndex = (index - 1 + tabs.length) % tabs.length;
      } else if (e.key === "Home") {
        newIndex = 0;
      } else if (e.key === "End") {
        newIndex = tabs.length - 1;
      } else if (e.key === "ArrowDown") {
        // Move focus to the corresponding panel
        e.preventDefault();
        const panel = document.querySelector(
          `#${tab.getAttribute("aria-controls")}`,
        );
        if (panel) {
          panel.focus();
        } else {
          console.error("Panel not found for focus");
        }
        return;
      }

      if (newIndex !== undefined) {
        e.preventDefault();
        switchTab(tabs[newIndex]);
      } else {
        console.log("🤷 Key not handled:", e.key);
      }
    });
  });

  panels.forEach((panel, index) => {
    panel.setAttribute("tabindex", "-1"); // Make panels focusable

    panel.addEventListener("keydown", (e) => {
      if (e.key === "ArrowUp") {
        // Move focus back to the corresponding tab
        e.preventDefault();
        const tab = document.querySelector(`[aria-controls="${panel.id}"]`);
        if (tab) {
          tab.focus();
        } else {
          console.error("❌ Tab not found for focus");
        }
      }
    });
  });
}
